import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Edit2FillIcon from "remixicon-react/Edit2FillIcon";
import DeleteBin5FillIcon from "remixicon-react/DeleteBin5FillIcon";
import { deletePageMappingSchema } from "../../../core/actionCreators/pageMappingActionCreator";
import toast from "react-hot-toast";

export const PageMappingStatusPill = (props: { value: any }) => {
  const isTrue = props.value === true || props.value === "true";
  return (
    <span className={`inline-block whitespace-nowrap px-1.5 py-0.5 rounded text-[11px] font-medium border ${isTrue ? "bg-green-100 text-green-800 border-green-200" : "bg-red-100 text-red-800 border-red-200"}`}>
      {isTrue ? "True" : "False"}
    </span>
  );
};

const PageMappingListItem = (props: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data } = props;

  const updateNavigateHandler = (id: any) => {
    navigate(`/pageMapping/${id}`);
  };

  const deletePageMappingHandler = (id: any) => {
    const shouldDelete = window.confirm("Are you sure you want to delete?");
    if (shouldDelete) {
      dispatch(
        deletePageMappingSchema(
          {
            id: id,
          },
          () => {
            toast.success("Deleted successfully");
          }
        )
      );
    }
  };

  if (!data.length) {
    return (
      <tr>
        <td colSpan={5} className="px-4 py-12 text-center text-xs text-gray-500">No page mappings found.</td>
      </tr>
    );
  }

  return (
    <>
      {data.map((_d: any) => (
        <tr key={_d.id} className="[&:nth-child(odd)]:bg-[#f7f7f7]">
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] font-medium">
            {_d.id}
          </td>
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] break-all">
            {_d.requestParam}
          </td>
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] break-all">
            {_d.layoutCodes}
          </td>
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">
            <PageMappingStatusPill value={_d.isWebView} />
          </td>
          <td className="px-4 py-3">
            <div className="flex items-center gap-3">
              <button
                onClick={() => updateNavigateHandler(_d.id)}
                className="text-blue-600 hover:text-blue-800 transition-colors"
                title="Update"
              >
                <Edit2FillIcon size={16} />
              </button>
              <button
                onClick={() => deletePageMappingHandler(_d.id)}
                className="text-red-600 hover:text-red-800 transition-colors"
                title="Delete"
              >
                <DeleteBin5FillIcon size={16} />
              </button>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};
export default PageMappingListItem;
